import React from "react";
import { connect } from "react-redux";
import UserProfile from "../../../Admin/components/userProfile";
import ChangePassword from "../../../Admin/components/changePassword";
import * as modalActions from "../../../utils/actions/modals";
import CreateRequestModal from "../../../Admin/components/createRequestModal";
import RequestDetailModal from "../../../Admin/components/requestDetailModal";
import ExportModal from "../../../Admin/components/exportModal";
import ThankYouModal, {
  PersonalViewSparkType,
} from "../../../Admin/components/thankYouModal";
import AddDonorModal from "../../../Admin/components/addDonorModal";
import SegmentManagerModal from "../../../Admin/components/segmentManagerModal";
import ColumnsModal from "../../../Admin/components/columnsModal";
import { ExportType } from "../../../Admin/components/exportModal";
import IRequest from "../../../types/services/IRequest";
import MediaModal from "../../../Admin/components/mediaModal";
import PostNotificationDetailsModal from "../../../Admin/components/postNotificationDetails";
import IColumnName from "../../../types/IColumnName";
import { IPost } from "../../../types/services/IPost";
import EditGiveUrlModal from "../../../Admin/components/Superadmin/editGiveUrlModal";
import IThankYouInfo from "../../../types/services/IThankYouInfo";
import CustomThumbnailModal from "../../../Admin/components/customThumbnailModal";
interface Props {
  showUpdateProfileModal: boolean;
  showChangePasswordModal: boolean;
  showExportModal: boolean;
  showThankYouModal: boolean;
  showEditGiveUrlModal: boolean;
  showColumnsModal: boolean;
  showCreateRequestModal: boolean;
  showRequestDetailModal: boolean;
  showMediaModal: boolean;
  showAddDonorModal: boolean;
  showSegmentManagerModal: boolean;
  showPostNotificationModal: boolean;
  showCustomThumbnailModal: boolean;

  toggleUpdateProfileModal: () => void;
  toggleChangePasswordModal: () => void;
  toggleExportModal: () => void;
  toggleThankYouModal: () => void;
  toggleEditGiveUrlModal: () => void;
  toggleUsersModal: () => void;
  toggleCreateRequestModal: () => void;
  toggleRequestDetailModal: () => void;
  toggleSegmentManagerModal: (
    donorId: string,
    updateComponentFunction?: () => void
  ) => void;
  toggleMediaModal: (blobUrls?: string[]) => void;
  toggleCustomThumbnailModal: (thumbnailBlob?: Blob) => void;
  toggleAddDonorModal: (
    donorFlagId?: string,
    donorFlagDonors?: Array<string>
  ) => void;
  togglePostNotificationModal: (post: IPost) => void;
  toggleColumnsModal: () => void;

  thanksThankYouInfos: Array<IThankYouInfo>;
  thanksModalType: PersonalViewSparkType;
  thanksGoAction: () => void;
  thanksDismissAction: () => void;
  thanksSkipOkConfirmation: boolean;

  charityId: string;
  charityName: string;
  charityCurrentGiveUrl: string;

  exportType: ExportType;
  exportIdsArray: Array<string>;
  exportTotalIds: string;
  exportFromDate: number;
  exportToDate: number;
  ignoreSelected: boolean;
  donorId: string;
  exportCharity: string;
  isFlag: boolean;
  donorIds: Array<string>;
  segmentId: string;
  filterBy: string;
  summaryExport: boolean;
  request: IRequest;
  columnNames: Array<IColumnName>;
  updateComponentFunction: () => void;
  changeColumnFunction: (index) => void;

  mediaBlobs?: string[];
  donorFlagId?: string;
  donorFlagDonors?: Array<string>;

  post?: IPost;
}

class Modals extends React.Component<Props, void> {
  render() {
    return (
      <div>
        {this.props.showPostNotificationModal && (
          <PostNotificationDetailsModal
            isOpen={this.props.showPostNotificationModal}
            toggle={this.props.togglePostNotificationModal}
            post={this.props.post}
          />
        )}
        <UserProfile
          isOpen={this.props.showUpdateProfileModal}
          toggle={this.props.toggleUpdateProfileModal}
        />
        <ChangePassword
          isOpen={this.props.showChangePasswordModal}
          toggle={this.props.toggleChangePasswordModal}
        />
        {this.props.showExportModal && (
          <ExportModal
            isOpen={this.props.showExportModal}
            toggle={this.props.toggleExportModal}
            exportType={this.props.exportType}
            exportIdsArray={this.props.exportIdsArray}
            exportTotalIds={this.props.exportTotalIds}
            exportFromDate={this.props.exportFromDate}
            exportToDate={this.props.exportToDate}
            ignoreSelected={this.props.ignoreSelected}
            donorId={this.props.donorId}
            exportCharity={this.props.exportCharity}
            isFlag={this.props.isFlag}
            donorIds={this.props.donorIds}
            segmentId={this.props.segmentId}
            filterBy={this.props.filterBy}
            summaryExport={this.props.summaryExport}
          />
        )}
        <ThankYouModal
          isOpen={this.props.showThankYouModal}
          toggle={this.props.toggleThankYouModal}
          thankYouInfos={this.props.thanksThankYouInfos}
          modalType={this.props.thanksModalType}
          goAction={this.props.thanksGoAction}
          dismissAction={this.props.thanksDismissAction}
          skipOkConfirmation={this.props.thanksSkipOkConfirmation}
        />
        <EditGiveUrlModal
          isOpen={this.props.showEditGiveUrlModal}
          toggle={this.props.toggleEditGiveUrlModal}
          charityId={this.props.charityId}
          charityName={this.props.charityName}
          charityCurrentGiveUrl={this.props.charityCurrentGiveUrl}
        />
        {this.props.showCreateRequestModal && (
          <CreateRequestModal
            isOpen={this.props.showCreateRequestModal}
            toggle={this.props.toggleCreateRequestModal}
          />
        )}
        <RequestDetailModal
          isOpen={this.props.showRequestDetailModal}
          toggle={this.props.toggleRequestDetailModal}
          request={this.props.request}
        />
        {this.props.showMediaModal && (
          <MediaModal
            isOpen={this.props.showMediaModal}
            toggle={this.props.toggleMediaModal}
            mediaBlobs={this.props.mediaBlobs}
          />
        )}
        {this.props.showCustomThumbnailModal && (
          <CustomThumbnailModal
            isOpen={this.props.showCustomThumbnailModal}
            toggle={this.props.toggleCustomThumbnailModal}
          />
        )}
        <AddDonorModal
          isOpen={this.props.showAddDonorModal}
          toggle={this.props.toggleAddDonorModal}
          donorFlagId={this.props.donorFlagId}
          donorFlagDonors={this.props.donorFlagDonors}
          isFlag={this.props.isFlag}
          donorIds={this.props.donorIds}
        />
        <ColumnsModal
          isOpen={this.props.showColumnsModal}
          changeColumnFunction={this.props.changeColumnFunction}
          columnNames={this.props.columnNames}
          toggle={this.props.toggleColumnsModal}
        />
        {this.props.showSegmentManagerModal && (
          <SegmentManagerModal
            isOpen={this.props.showSegmentManagerModal}
            toggle={this.props.toggleSegmentManagerModal}
            updateComponentFunction={this.props.updateComponentFunction}
            donorId={this.props.donorId}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { modals } = state;
  return {
    showLoginModal: modals.showLoginModal,
    showUpdateProfileModal: modals.showUpdateProfileModal,
    showChangePasswordModal: modals.showChangePasswordModal,
    showExportModal: modals.showExportModal,
    showThankYouModal: modals.showThankYouModal,
    showEditGiveUrlModal: modals.showEditGiveUrlModal,
    showCreateRequestModal: modals.showCreateRequestModal,
    showRequestDetailModal: modals.showRequestDetailModal,
    showMediaModal: modals.showMediaModal,
    showCustomThumbnailModal: modals.showCustomThumbnailModal,
    showAddDonorModal: modals.showAddDonorModal,
    showSegmentManagerModal: modals.showSegmentManagerModal,
    showColumnsModal: modals.showColumnsModal,
    updateComponentFunction: modals.updateComponentFunction,

    changeColumnFunction: modals.changeColumnFunction,

    thanksThankYouInfos: modals.thankYouInfos,
    thanksModalType: modals.modalType,
    thanksGoAction: modals.goAction,
    thanksDismissAction: modals.dismissAction,
    thanksSkipOkConfirmation: modals.skipOkConfirmation,

    charityId: modals.charityId,
    charityName: modals.charityName,
    charityCurrentGiveUrl: modals.charityCurrentGiveUrl,

    exportType: modals.exportType,
    exportIdsArray: modals.exportIdsArray,
    exportTotalIds: modals.exportTotalIds,
    exportFromDate: modals.exportFromDate,
    exportToDate: modals.exportToDate,
    ignoreSelected: modals.ignoreSelected,
    donorId: modals.donorId,
    exportCharity: modals.exportCharity,
    isFlag: modals.isFlag,
    donorIds: modals.donorIds,
    segmentId: modals.segmentId,
    filterBy: modals.filterBy,
    summaryExport: modals.summaryExport,
    request: modals.request,
    columnNames: modals.columnNames,

    mediaBlobs: modals.mediaBlobs,
    donorFlagId: modals.donorFlagId,
    donorFlagDonors: modals.donorFlagDonors,

    showPostNotificationModal: modals.showPostNotificationModal,
    post: modals.post,
  };
};

const mapDispatchToProps = dispatch => ({
  toggleUpdateProfileModal: () => {
    dispatch(modalActions.toggleUserProfileModal());
  },
  toggleChangePasswordModal: () => {
    dispatch(modalActions.toggleChangePasswordModal());
  },
  toggleThankYouModal: () => {
    dispatch(modalActions.toggleThankYouModal());
  },
  toggleEditGiveUrlModal: () => {
    dispatch(modalActions.toggleEditGiveUrlModal());
  },
  toggleExportModal: () => {
    dispatch(modalActions.toggleExportModal());
  },
  toggleCreateRequestModal: () => {
    dispatch(modalActions.toggleCreateRequestModal());
  },
  toggleRequestDetailModal: () => {
    dispatch(modalActions.toggleRequestDetailModal());
  },
  toggleSegmentManagerModal: (
    donorId: string,
    updateComponentFunction?: () => void
  ) => {
    dispatch(
      modalActions.toggleSegmentManagerModal(donorId, updateComponentFunction)
    );
  },
  toggleMediaModal: blobUrls => {
    dispatch(modalActions.toggleMediaModal(blobUrls, false));
  },
  toggleCustomThumbnailModal: (thumbnailBlob?: Blob) => {
    dispatch(modalActions.toggleCustomThumbnailModal(thumbnailBlob));
  },
  toggleAddDonorModal: (donorFlagId, donorFlagDonors) => {
    dispatch(modalActions.toggleAddDonorModal(donorFlagId, donorFlagDonors));
  },
  toggleColumnsModal: () => {
    dispatch(modalActions.toggleColumnsModal());
  },
  togglePostNotificationModal: post => {
    dispatch(modalActions.togglePostNotificationModal(post));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
